import _regeneratorRuntime from "D:\\agent\\_work\\100\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
import config from "./config";
export var postLog = function postLog(logLevel, message) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios({
              url: "api/log/".concat(logLevel),
              baseURL: config.apiUrl,
              method: "post",
              data: JSON.stringify(message),
              headers: {
                "Content-Type": "application/json",
                accept: "application/json"
              }
            });
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};